/**
 * dir-w | backOffice
 * Show progress on status bar
 *
 * Last update : August 18, 2024 | @rizkiprasetya
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusBarService implements OnDestroy {
  private subject = new Subject<any>();
  constructor() {}

  /**
   *
   */
  ngOnDestroy(): void {
    this.subject.unsubscribe();
  }

  /**
   * Sent an update messaget to subject
   * @param message string message
   */
  statusBarUpdate(message: string): void {
    //the component that wants to update something, calls this fn
    //next() will feed the value in Subject
    this.subject.next({ text: message });
  }

  /**
   * Reset the status bar to ready . . .
   */
  statusBarReset(): void {
    this.subject.next({ text: 'Ready . . .' });
  }


  /**
   * Get updates from subject via observable
   * @returns Observable<any>
   */
  getUpdate(): Observable<any> {
    // the receiver component calls this function
    // it returns as an observable to which the receiver funtion will subscribe
    return this.subject.asObservable();
  }
}
